import React,{useState,useEffect} from "react";
import { Grid, Card, CardContent, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import socket from '../tools/socke';
import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";
import axios from 'axios';
import CadeteFormEdit from "./CadeteFormEdit";
import * as XLSX from 'xlsx';
import Modal from "./Modal";
import InfoModalCuerpo from "../Cuerpo/InfoModalCuerpo";
const CadetesDashboard = ({ sede}) => {
const Usuario=ObtieneDatosCookies
 const [dataSeleccionada,setDataSeleccionada]=useState([])
const [data,setData]=useState("")
const [verListados,setVerListados]=useState("")

  const traemeLosDayos = async () => {
    try {
      const compania =
        Usuario.destino === 7 || Usuario.destino === 1 || Usuario.destino === 2 || Usuario.destino === 20
          ? ""
          : Usuario.dependenciaNombre;

      const client = axios.create({
        baseURL: "https://wwwa.isepsantafe.net.ar/expedientes/obtengoParteInstantaneo",
      });

      const fechaHoy = new Date();
      const año = fechaHoy.getFullYear();
      const mes = String(fechaHoy.getMonth() + 1).padStart(2, "0");
      const dia = String(fechaHoy.getDate()).padStart(2, "0");
      const fechaFormateada = `${año}-${mes}-${dia}`;

//       console.log("Fecha enviada:", fechaFormateada);
//       console.log("Compañía enviada:", compania);

      const response = await client.post("/", {
        fecha: fechaFormateada,
        sede:sede,
      });
console.log("Respuesta del servidor:", response.data); // Agrega este console.log para ver la respuesta completa
      if (response && response.data) {
//         console.log("Datos recibidos:", response.data);

        if (response.data.length > 0) {
          setData(response.data);
         
        } else {
//           console.log("No hay datos para mostrar.");
        }
      } else {
        console.error("No se recibieron datos válidos:", response);
      }
    } catch (error) {
      console.error("Error al obtener los datos del parte instantáneo:", error);
    }
  };

  useEffect(() => {
  
    traemeLosDayos();
    
    const handlePresenteCadete = () => {
//       console.log("Recibiendo datos...");

    
      traemeLosDayos();
    };

    socket.on('listaPresentes', handlePresenteCadete);

    return () => {
      socket.off('listaPresentes', handlePresenteCadete);
    };
  }, []);

  if (!data || !data.length) {
    return <Typography variant="h6">Cargando datos...</Typography>;
  }
const manejoModal=(datos)=>{
//   console.log(datos)
  setDataSeleccionada(datos)
  setVerListados(true)
}

  return (<>{data?    <div style={{maxWidth:"600px"}}>
    <Grid container spacing={1} padding={0} style={{justifyContent:"center"}}>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              PARTE INSTANTANEO: {sede}
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>AÑO</TableCell>
                    <TableCell>F.E</TableCell>
                    <TableCell>F.P</TableCell>
                    <TableCell>F.A</TableCell>
                    <TableCell>Pases</TableCell>
                    <TableCell>F.F</TableCell>
                    
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.promocion=="2025-2026"?"2DO":"1ERO"}</TableCell>
                      <TableCell onClick={() => manejoModal(item)}>{item.FE}</TableCell>
                      <TableCell onClick={() => manejoModal(item)}>{item.FP}</TableCell>
                      <TableCell onClick={() => manejoModal(item)}><>{item.FA}{item.Pases.length>0? " (Incluye Pases)":""} </></TableCell>
                      <TableCell onClick={() => manejoModal(item)}>{item.Pases.length>0?item.Pases.length:0}</TableCell>
                      <TableCell onClick={() => manejoModal(item)}>{item.FF}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Grid>
    </Grid></div>:""}
    <div>
    {verListados && dataSeleccionada&& (
        <Modal isOpen={verListados} onClose={() => setVerListados(false)}>
          <div
            style={{
              padding: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{overflowY:"auto", height:"500px"}}>
              <InfoModalCuerpo datos={dataSeleccionada} sede={sede}/>
              
            </div>
        
          </div>
        </Modal>
      )}
    </div>
</>
  );
};

export default CadetesDashboard;

